var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("rect", {
        attrs: { width: "32", height: "32", fill: "#FFE252", rx: "4" }
      }),
      _c("path", {
        attrs: {
          fill: "#7FDECB",
          d:
            "M16.046 6.537c-.092 0-.092-.046 0 0ZM15.909 7.177c.045.046.137.046.182.092a.346.346 0 0 0-.182-.092Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#02016F",
          d: "M26 16.5a9.5 9.5 0 1 0-1.894 5.692L16.5 16.5H26Z"
        }
      }),
      _c("path", {
        attrs: { fill: "#4868FD", d: "M26 16.5a9.5 9.5 0 1 0-9.5 9.5v-9.5H26Z" }
      }),
      _c("path", {
        attrs: {
          fill: "#F2F2F7",
          d: "M23.218 23.218A9.5 9.5 0 0 0 21.82 8.63L16.5 16.5l6.718 6.718Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }